/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Dialog, Text, ListItem, UnorderedList } from 'evergreen-ui'
import withAuthentication from 'components/withAuthentication/withAuthentication'

class Navigation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isShown: false
    }
  }

  authenticatedMenu() {
    const { roles } = this.props
    return(
      <ul className='header-navigation'>
        {['admin', 'clinic'].some(permission => roles.includes(permission)) && <li><Link to='/log'>Log My Parvo Case</Link></li>}
        <li>
          <Link to='/map'>Parvo Maps & Alerts</Link>
        </li>
        <li>
          <Link to='/graph'>Parvo graphs & hotspots</Link>
        </li>
        {
          ['admin', 'clinic'].some(permission => roles.includes(permission)) ?
          <li><Link to='/case-reports'>My case reports</Link></li> :
          <li><Link to='/account'>My account details & alerts</Link></li>
        }
        <li>
          <Link to='/vaccination'>Parvo vaccination projects</Link>
        </li>
      </ul>
    )
  }

  unAuthenticatedMenu() {
    return(
      <ul className='header-navigation'>
        <li>
          <Link to='/about'>About Us</Link>
        </li>
        <li>
          <Link to='/funding'>Funding the Project</Link>
        </li>
        <li>
          <Link to='/media'>Media Enquiries</Link>
        </li>
        <li>
          <a href="#" onClick={this.toggleModal}>Share</a>
        </li>
        <li><Link to='/contact'>Contact Us</Link></li>
      </ul>
    )
  }

  toggleModal = () => {
    this.setState({
      isShown: !this.state.isShown
    })
  }

  render() {
    const { isAuthenticated } = this.props
    const { isShown } = this.state

    return(
      <React.Fragment>
        <nav>
          {
            isAuthenticated ? this.authenticatedMenu() : this.unAuthenticatedMenu()
          }
        </nav>
        <Dialog
          isShown={isShown}
          title="Please Help Spread the Word About Parvo ALERT!"
          onCloseComplete={() => this.setState({ isShown: false })}
          hasFooter={false}
        >
          <Text size={500}>
            The only way we will stop this disease is by raising awareness so that everyone knows what Parvo is, and the importance of disease prevention. You can help play a vital part in this project!
          </Text>
          <UnorderedList
            size={500}
          >
            <ListItem>
              Please inform people about the Parvo outbreaks displayed on Parvo ALERT by <strong>posting images of our maps on your websites and social media</strong>. (Please ensure you include a link to www.ParvoALERT.com when you do, and state that the image is “Reproduced with permission from www.ParvoALERT.com)
            </ListItem>
            <ListItem>
              <strong>
                Please quote Parvo ALERT in your media releases and media articles, and newsletters and communications
              </strong>
            </ListItem>
            <ListItem>
              <strong>
                Please tell your dog-owning friends and colleagues about Parvo ALERT
              </strong>, especially if you are in an at-risk area for Parvo, and tell them to go to the website and set up their own alerts to be notified when outbreaks occur.
            </ListItem>
            <ListItem>
              <strong>
                Use our hashtag in your social media posts
              </strong>
              to spread the word about Parvo!
            </ListItem>
          </UnorderedList>
          <Text size={500}>Thanks for supporting this important work!<br />#MakeParvoHistory</Text>
        </Dialog>
      </React.Fragment>
    )
  }
}

export default withAuthentication(Navigation)
